import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

export const useClipboard = () => {
    const { enqueueSnackbar } = useSnackbar();

    const copyToClipboard = useCallback(
        async (text: string, successMessage?: string) => {
            try {
                // Essayer d'abord avec l'API moderne
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(text);
                } else {
                    // Fallback pour les navigateurs plus anciens ou contextes non-sécurisés
                    const textArea = document.createElement('textarea');
                    textArea.value = text;
                    textArea.style.position = 'fixed';
                    textArea.style.opacity = '0';
                    textArea.style.pointerEvents = 'none';
                    document.body.appendChild(textArea);
                    textArea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textArea);
                }

                enqueueSnackbar(successMessage || 'Contenu copié dans le presse-papiers', {
                    variant: 'success',
                    autoHideDuration: 2000,
                });

                return true;
            } catch (error) {
                console.error('Erreur lors de la copie:', error);
                enqueueSnackbar('Erreur lors de la copie dans le presse-papiers', {
                    variant: 'error',
                });
                return false;
            }
        },
        [enqueueSnackbar],
    );

    return { copyToClipboard };
};
